export default __webpack_public_path__ + "static/media/Blog4.b540a1d4.png";